var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBoxValid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.2857V19.2481C24 21.8947 21.8346 24 19.2481 24H4.75188C2.10526 24 0 21.8346 0 19.2481V4.75188C0 2.10526 2.16541 0 4.75188 0H20.9925C21.8947 0 22.3759 1.20301 21.7143 1.86466L13.4135 10.1053C12.6316 10.8872 11.3083 10.8872 10.5263 10.1053L7.6391 7.21804C7.03759 6.61654 6.07519 6.61654 5.53383 7.21804L3.54887 9.20301C2.94737 9.80451 2.94737 10.7669 3.54887 11.3083L10.8872 18.6466C11.4887 19.2481 12.391 19.2481 12.9925 18.6466L22.1353 9.50376C22.8571 8.90226 24 9.38346 24 10.2857Z",
    fill: "#FE5000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxValid);
export default __webpack_public_path__ + "static/media/CheckBoxValid.aede20b8.svg";
export { ForwardRef as ReactComponent };